import type { Issue } from '~/components/page/Automation/v2/state/flowIssues';
import type { RelativeMaps } from '~/components/page/Automation/v2/types';
import type { Flow___ArgumentFragment } from '~/graphql/types';
import type { ClientFlowAction } from '~/graphql/types.client';
import getPathForPointer from '../../../../components/Selector/utils/getPathForPointer';
import type { Flow___SubjectIdentifier } from '../../../../components/Selector/utils/getSubject';

const collectIssuesForArgument = (
  action: ClientFlowAction,
  argument: Flow___ArgumentFragment,
  relativeMaps?: RelativeMaps,
  opts?: {
    /** When given, the pointer must also resolve to one of these subjects */
    validTypes?: Array<Flow___SubjectIdentifier>;
  },
) => {
  const issues: Array<Issue> = [];
  if (!relativeMaps) return [];

  if (argument.__typename === 'Flow___Argument_Pointer') {
    if (argument.pointer.path.length === 0) {
      return [];
    }

    const pathToPointer = getPathForPointer(argument.pointer, {
      ...relativeMaps,
      validTypes: opts?.validTypes,
    });

    if (pathToPointer.error) {
      issues.push({
        message:
          'Er mist een variabele, waarschijnlijk heb je een stap aangepast of verwijderd',
        level: 'error',
        type: 'BadVariableIssue',
        actionId: action.id,
        actionType: action.actionType,
      });
    }
  }

  return issues;
};

export default collectIssuesForArgument;
